"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMirrorValuesToKeepTextRightSideUp = getMirrorValuesToKeepTextRightSideUp;
function getMirrorValuesToKeepTextRightSideUp(angleDegrees) {
    if (angleDegrees - Number.EPSILON >= 180 || (angleDegrees < 0 && angleDegrees !== -90)) {
        return [true, true];
    }
    else {
        return [false, false];
    }
}
//# sourceMappingURL=getMirrorValuesToKeepTextRightSideUp.js.map